import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { CrudBqResponse } from './types';

export const documentEndpoint = {
  server: defaultServer,
  path: 'crud/document',
  description: 'Document operations',
};

const endpointDocumentExec =
  getExecEndpoint<DocumentEndpointDef>(documentEndpoint);

export const endpointDocumentGET = async (id: string) => {
  const response = await endpointDocumentExec<'GET'>({
    method: 'GET',
    urlExtra: `/${id}`,
  });

  if (!response) {
    throw new Error('Could not get document');
  }

  if (response.success === 0) {
    throw new Error('Could not get document');
  }

  return response;
};

export interface DocumentEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: DocumentGetDataResponse;
    };
    POST: {
      payload: DocumentPostPayload;
      response: DocumentPostResponse;
    };
  };
}

export type DocumentPostResponse = CrudBqResponse<{ id: string }>;

export type DocumentGetDataResponse = CrudBqResponse<DocumentGetData>;

export type DocumentPostPayload = Omit<
  DocumentGetData,
  'id' | 'createdAt' | 'updatedAt'
>;

export type DocumentGetData = {
  id: string;
  internalUrl: string;
  originalName: string;
  extractionStatus: string;
  liveness: boolean;
  restated: string;
  type: string;
  source: string;
  deletedAt: string | null;
  createdBy: string;
  companyId: string;
  fundId: string;
  portfolioCompanyId: string;
  gDriveParentFolderId: string | null;
  gDriveFileId: string | null;
  createdAt: string;
  updatedAt: string;
};
